module.exports = __webpack_public_path__ + "img/nevs_level_S.549acbf0.png";